import { createFileRoute, Navigate } from "@tanstack/react-router";
export const Route = createFileRoute("/_authed/archived")({ component: () => <Navigate to="/" replace /> });
